import MrclText from '../../marcel/MrclText';
import { useTranslation } from 'react-i18next';
import { Card, EmptyState } from './commonComponents';

const LoadingCard = () => {
    const {t} = useTranslation();
    
    return (
        <Card>
            <EmptyState>
                <MrclText
                    style={{
                        margin: 0,
                        fontSize: 14,
                        color: "#64748b",
                        fontWeight: 500,
                    }}
                >
                    {t('common.chargement')}
                </MrclText>
            </EmptyState>
        </Card>
    );
};

export default LoadingCard;